import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { UserMessage } from '../../DesignSystem/LiliUserMessage/UserMessage';
import Spinner, { SpinnerColor } from '../../generic-components/Spinner';

interface IProps {
  shouldShowSkeleton?: boolean;
}

export const FullPageLoader = ({ shouldShowSkeleton }: IProps) => (
  !shouldShowSkeleton ? (
    <div className='absolute inset-0 flex items-center justify-center'>
      <UserMessage onClick={() => {}} id='spinnerLoader'>
        <Spinner spinnerColor={SpinnerColor.Blue} height='50px' width='50px' />
      </UserMessage>
    </div>
  ) : (
    <div className='flex flex-col items-center gap-[20px]'>
      <Skeleton width='80px' height='60px' />
      <Skeleton width='300px' height='60px' />
      <Skeleton width='200px' height='60px' />
      <Skeleton width='400px' height='60px' />
    </div>
  )
);
